import * as app from 'actions/AppActions';
import * as availability from 'actions/AvailabilityActions';
import * as batch from 'actions/BatchActions';
import * as business from 'actions/BusinessActions';
import * as calendar from 'actions/CalendarActions';
import * as checkout from 'actions/CheckoutActions';
import * as communication from 'actions/CommunicationActions';
import * as consumerPage from 'actions/ConsumerPageActions';
import * as cookieConsent from '@tock/shared/actions/CookieConsentActions';
import * as csrfTokenActions from '@tock/shared/actions/CsrfTokenActions';
import * as delivery from 'actions/DeliveryActions';
import * as discover from 'actions/DiscoverActions';
import * as experiments from 'actions/ExperimentActions';
import * as giftCard from 'actions/GiftCardActions';
import * as history from 'actions/HistoryActions';
import * as lastGuest from 'actions/LastGuestActions';
import * as lock from 'actions/LockActions';
import * as loyaltyProgram from 'actions/LoyaltyProgramActions';
import * as metroArea from 'actions/MetroAreaActions';
import * as navigation from 'actions/NavigationActions';
import * as packageActions from 'actions/PackageActions';
import * as partnerRole from 'actions/PartnerRoleActions';
import * as patron from 'actions/PatronActions';
import * as paymentCard from '@tock/shared/actions/PaymentCardActions';
import * as playlist from 'actions/PlaylistActions';
import * as privateDining from 'actions/PrivateDiningActions';
import * as purchase from 'actions/PurchaseActions';
import * as queryParam from 'actions/QueryParamActions';
import * as reschedule from 'actions/RescheduleActions';
import * as reserveWithGoogle from 'actions/ReserveWithGoogleActions';
import * as scrollDetector from 'actions/ScrollDetectorActions';
import * as search from 'actions/SearchActions';
import * as selection from 'actions/SelectionActions';
import * as supplementGroups from 'actions/SupplementGroupsActions';
import * as syndicate from 'actions/SyndicatedBookingActions';
import * as tableSide from 'actions/TableSideActions';
import * as theme from 'actions/ThemeActions';
import * as tockGiftCard from 'actions/TockGiftCardActions';
import * as transfer from 'actions/TransferActions';
import * as ui from 'actions/UIActions';
import * as waitlist from 'actions/WaitlistActions';
import * as widgetBuilder from 'actions/WidgetBuilderActions';
import { actions as toast } from '@tock/toast';

export const actions = {
  app,
  availability,
  batch,
  business,
  calendar,
  cookieConsent,
  communication,
  consumerPage,
  checkout,
  csrfTokenActions,
  delivery,
  discover,
  experiments,
  giftCard,
  history,
  lastGuest,
  lock,
  loyaltyProgram,
  metroArea,
  navigation,
  packageActions,
  partnerRole,
  patron,
  paymentCard,
  playlist,
  privateDining,
  purchase,
  queryParam,
  reschedule,
  reserveWithGoogle,
  search,
  selection,
  scrollDetector,
  supplementGroups,
  syndicate,
  tableSide,
  theme,
  toast,
  tockGiftCard,
  transfer,
  ui,
  waitlist,
  widgetBuilder,
};
